<template>
<div class="row" v-if="team && roster">
    <messageModal v-if="showMessage" message="les achats sont enregistrés" @closeMessage="goToDetail"></messageModal>
    <messageModal v-if="showErrorModal" message="mmmhhh Quelque chose s'est mal passé. Contactez l'admin. Désolé pour ça." @closeMessage="showErrorModal=false"></messageModal>
    <playerPurchaseModal v-if="showPlayerPurchaseModal" :team="team" :roster="roster" :purchaseList="playerToPurchase" @closeMessage="showPlayerPurchaseModal = false" @validate='updatePlayerPurchases'></playerPurchaseModal>
    <confirmModal v-if="showFinishPurchasesConfirmModal"
                  message="On valide ces achats ?"
                  @confirm="confirmValidatePurchases"
                  @closeMessage="showFinishPurchasesConfirmModal = false"></confirmModal>
    <spinningModal v-if="showSpinner"></spinningModal>
    <spiralingExpenseModal v-if="showSpiralingExpenseModal"
                           :spiralingExpenseResult="spiralingExpenseResult"
                           @closeMessage="goToDetail"></spiralingExpenseModal>
        <div class="panel">
            <div class="panel-content">
                <div class="row columns">
                    <div class="panel-title">
                        Gérez les achats pour votre équipe ! vous avez {{currentTreasury}} 000 po en caisse
                    </div>
                    <div class="row">
                        <div class="large-9 large-centered note">
                        Choisissez votre section et faites votre shopping.
                        </div>
                    </div>
                    <br>
                    <ul class="tabs horizontal" data-tab>
                        <li @click="activatedTab = 1"><a :class="{activated : activatedTab === 1}">Joueurs & Journaliers</a></li>
                        <li @click="activatedTab = 2"><a :class="{activated : activatedTab === 2}">Encadrement</a></li>
                        <li @click="activatedTab = 4"><a :class="{activated : activatedTab === 4}">Stades</a></li>
                    </ul>
                    <br>
                    <div class="inner-tab">
                        <player-purchase ref="playerPurchaser"
                                         :hidden="activatedTab != 1" :roster="roster"
                                         @updatePlayerCost="updatePlayerCost()"
                                         :team="team"
                                         :currentTreasury="currentTreasury"></player-purchase>
                        <stuff-purchase ref="stuffPurchaser"
                                        :hidden="activatedTab != 2"
                                        @updateStuffCost="updateStuffCost()"
                                        :roster="roster"
                                        :team="team"
                                        :currentTreasury="currentTreasury"></stuff-purchase>
                        <star-purchase  ref="starPurchaser"
                                        :hidden="activatedTab != 3"
                                        @updateStarCost="updateStarCost()"
                                        :roster="roster"
                                        :team="team"
                                        :currentTreasury="currentTreasury"></star-purchase>
                        <stadium-purchase  ref="stadiumPurchaser"
                                        :hidden="activatedTab != 4"
                                        @updateStadiumCost="updateStadiumCost()"
                                        :roster="roster"
                                        :team="team"
                                        :currentTreasury="currentTreasury"></stadium-purchase>
                    </div>
                    <div class="row columns">
                       <div class="large-6 large-offset-3 inner-title">
                          Mon Panier
                       </div>
                       <div class="large-6 large-offset-3 inner-subtitle">
                         Récapitulons vos achats
                       </div>
                       <div class="large-6 large-offset-3 inner-subtitle">
                          <table>
                               <thead>
                                  <tr class="">
                                      <th width="20%">
                                      <th width="40%">Type</th>
                                      <th width="40%">coût total</th>
                                  </tr>
                              </thead>
                              <tbody class="roster" v-if ="roster">
                                  <tr v-if="totalPlayerCost > 0">
                                      <td></td>
                                      <td>Joueurs supplémentaires</td>
                                      <td>{{totalPlayerCost}} 000</td>
                                  </tr>
                                  <tr v-if="totalStuffCost > 0">
                                      <td></td>
                                      <td>Encadrement</td>
                                      <td>{{totalStuffCost}} 000</td>
                                  </tr>
                                  <tr v-if="totalStarCost > 0">
                                      <td></td>
                                      <td>Star Player</td>
                                      <td>{{totalStarCost}} 000</td>
                                  </tr>
                                  <tr v-if="totalStadiumCost > 0">
                                      <td></td>
                                      <td>Stades</td>
                                      <td>{{totalStadiumCost}} 000</td>
                                  </tr>
                                  <tr>
                                      <td></td>
                                      <td class="summary">budget total</td>
                                      <td class="summary">{{totalBudget}} 000</td>
                                  </tr>
                              </tbody>
                          </table>
                       </div>
                    </div>
                    <div class="row">
                        <div class="large-3 large-centered columns">
                            <router-link :to="{ name: 'TeamDetail', params: { id: team.id.toString() }}" >
                              <button class="light-grey-button">Annuler</button>
                            </router-link>
                            <button v-if="currentTreasury >= 0" @click="validatePurchases" class="">Valider</button>
                            <button v-else class="deactivated" disabled>Valider</button>
                        </div>
                    </div>
                    <br>
                    <div class="row">
                        <div v-if="currentTreasury >= 0" class="team-value large-5 large-centered columns note">
                        Il vous restera {{currentTreasury}} 000 piéces d'or après achat
                        </div>
                        <div v-else class="team-value large-5 large-centered columns note red">
                          Impossible de valider les achats, vous avez {{-currentTreasury}} 000 d'achats en trop
                        </div>
                    </div>
                    <div v-if="errorMsg" class="row">
                        <div class="large-12 large-centered columns text-centered">
                            <div class="error text-centered">{{errorMsg}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
</div>
<div v-else>
  <spinner></spinner>
</div>
</template>

<script>
import store from '../../store/index.js'
import { mapGetters } from 'vuex'
import spinner from '../common/spinner.vue'
import spinningModal from '../common/spinning-modal.vue'
import teamPurchases from '../../api/team-purchases.api'
import messageModal from '../common/message-modal.vue'
import confirmModal from '../common/confirm-modal'
import playerPurchaseModal from '../common/player-purchase-modal.vue'
import playerPurchase from './purchases/player-purchase'
import stuffPurchase from './purchases/stuff-purchase'
import starPurchase from './purchases/star-purchase'
import stadiumPurchase from './purchases/stadium-purchase'
import spiralingExpenseModal from '../common/spiraling-expense-modal.vue'

export default {
  name: 'teamPurchases',
  components: {
    spinner,
    messageModal,
    confirmModal,
    spinningModal,
    spiralingExpenseModal,
    playerPurchaseModal,
    playerPurchase,
    stuffPurchase,
    starPurchase,
    stadiumPurchase
  },
  props: {
    'id': String
  },
  data () {
    return {
      // la liste des joueurs actuellement présents dans l'équipe, et de ceux que l'on achète
      playerToPurchase: [],
      purchases: {},
      apo: 0,
      nbRerolls: 0,
      assistants: 0,
      pompoms: 0,
      errorMsg: null,
      isInit: false,
      showMessage: false,
      showPlayerPurchaseModal: false,
      activatedTab: 1,
      totalPlayerCost: 0,
      totalStuffCost: 0,
      totalStarCost: 0,
      totalStadiumCost: 0,
      showFinishPurchasesConfirmModal: false,
      showSpinner: false,
      showSpiralingExpenseModal: false,
      showErrorModal: false
    }
  },
  computed:
  {
    ...mapGetters([
      'currentUser'
    ]),
    ...mapGetters({
      roster: 'detailedRoster',
      team: 'detailedTeam'
    }),
    currentTreasury: function () {
      return this.team.treasury - this.totalBudget
    },
    totalBudget: function () {
      return this.totalPlayerCost + this.totalStuffCost + this.totalStarCost + this.totalStadiumCost
    }
  },
  watch: {
    team: function (newVal, oldVal) {
      if (newVal) {
        this.$store.dispatch('getDetailedRoster', newVal.ref_roster.id)
      }
    }
  },
  methods: {
    updatePlayerCost () {
      let playerCost = 0
      if (this.$refs.playerPurchaser) {
        this.totalPlayerCost = this.$refs.playerPurchaser.totalPlayerCost
        return
      }
      this.totalPlayerCost = playerCost
    },
    updateStuffCost () {
      let stuffCost = 0
      if (this.$refs.stuffPurchaser) {
        this.totalStuffCost = this.$refs.stuffPurchaser.totalStuffCost
        return
      }
      this.totalStuffCost = stuffCost
    },
    updateStarCost () {
      if (this.$refs.starPurchaser) {
        this.totalStarCost = this.$refs.starPurchaser.starCost
        return
      }
      this.totalStarCost = 0
    },
    updateStadiumCost () {
      if (this.$refs.stadiumPurchaser) {
        this.totalStadiumCost = this.$refs.stadiumPurchaser.stadiumBudget
        return
      }
      this.totalStadiumCost = 0
    },
    testdatas () {
      console.log(this.$refs)
    },
    goToDetail () {
      store.dispatch('getDetailedTeam', this.id.toString())
      this.showMessage = false
      this.showSpiralingExpenseModal = false
      this.$router.push({name: 'TeamDetail', params: { id: this.id.toString() }})
    },
    validatePurchases () {
      this.showFinishPurchasesConfirmModal = true
    },
    confirmValidatePurchases () {
      this.showFinishPurchasesConfirmModal = false

      // si pas d'achat, on sort
      if (this.currentTreasury === this.team.treasury) {
        this.finishPurchases()
        return
      }
      if (this.creationStarted === false) {
        this.creationStarted = true
      }
      if (this.currentTreasury < 0) {
        this.errorMsg = 'Le montant des achats dépasse celui de la trésorerie'
        return
      }
      this.purchases = {}
      this.purchases.hire = {}
      // gestion du stuff
      if (this.$refs.stuffPurchaser.apo === 1) {
        this.purchases.hire.apo = true
      }
      if (this.$refs.stuffPurchaser.nbRerolls > 0) {
        this.purchases.hire.reroll = this.$refs.stuffPurchaser.nbRerolls
      }
      if (this.$refs.stuffPurchaser.assistants > 0) {
        this.purchases.hire.assistants = this.$refs.stuffPurchaser.assistants
      }
      if (this.$refs.stuffPurchaser.pompoms > 0) {
        this.purchases.hire.cheerleaders = this.$refs.stuffPurchaser.pompoms
      }

      // gestion des stars
      if (this.$refs.starPurchaser.purchaseNewStar()) {
        this.purchases.hire.star_player = {}
        this.purchases.hire.star_player.num = 0
        this.purchases.hire.star_player.ref_star_player = this.$refs.starPurchaser.chosenStarPlayer.id
      }
      if (this.$refs.starPurchaser.paySalary()) {
        this.purchases.hire.star_player_salary = 'pay'
      }

      // gestion des stades
      if (this.$refs.stadiumPurchaser.saveMoney) {
        this.purchases.hire.stadium = this.$refs.stadiumPurchaser.saveMoneyCost
      }

      if (this.$refs.stadiumPurchaser.stadiumPurchase) {
        this.purchases.hire.full_stadium = this.$refs.stadiumPurchaser.missingMoneyForStadium
      }

      // gestion des nouveaux joueurs
      // on ajoute les joueurs à acheter à la structure d'achat, si il y en a
      // et on fait monter la modal de choix des numéros
      let playersToPurchase = this.$refs.playerPurchaser.getDatas()
      if (playersToPurchase.players || playersToPurchase.journeymen) {
        this.purchases.hire.players = playersToPurchase.players
        this.purchases.hire.journeymen = playersToPurchase.journeymen
        this.playerToPurchase = playersToPurchase
        this.showPlayerPurchaseModal = true
      } else {
        // si on a pas de joueurs à acheter, on peut publier directement les achats
        this.publishPurchases()
      }
    },
    updatePlayerPurchases (updatedPlayerDatas) {
      this.showPlayerPurchaseModal = false
      this.purchases.hire.players = updatedPlayerDatas.players
      this.purchases.hire.journeymen = updatedPlayerDatas.journeymen
      console.log(this.purchases)
      this.publishPurchases()
    },
    publishPurchases () {
      this.showSpinner = true
      teamPurchases.api.publishTeamPurchases(this.team.id, this.purchases)
      .then(response => {
        this.goToDetail()
      },
      error => {
        console.log('erreur impossible to publish purchases')
        console.log(error)
      })
    }
  },
  created () {
    store.dispatch('hideLeaguePanel')
    store.dispatch('deactivateFullSizePage')
    store.dispatch('getDetailedTeam', this.id.toString())
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.roster{
    font-weight: 300;
}

.roster tr:nth-of-type(odd) {
    transition: background-color 0.15s;
    background-color: #E9EDEF;
}

.roster tr:nth-of-type(even) {
    background-color: #ffffff;
}

/***** gestion des formats de cellules*/

thead tr th {
    background-color: #ffffff;
    text-align: center;
    font-weight: 200;
    font-size:0.8rem;
}

.roster tr td{
    padding: 0.5rem 0rem;
    text-align: center;
    font-size:0.7rem;
}

.roster tr td.sous-total{
    font-weight: 400;
    padding: 0.4rem 0rem;
}


.roster tr td.sous-total.right{

}

button.row{
    margin-left: 0.4rem;
}

.team-score {
    font-size: 2rem;
    font-weight: 450;
    padding-top: 1rem;
    padding-bottom: 0.2rem;
    padding-left: 0.2rem;
}

.match-result {
    font-size: 1.2rem;
    font-weight: 200;
    padding-bottom: 0.2rem;
    padding-left: 0.2rem;
}

.match-team-name {
    font-size: 1.7rem;
    font-weight: 300;
    padding-top: 1rem;
    padding-bottom: 0.2rem;
    padding-left: 0.2rem;
}
.roster tr td.action{
    padding: 0.4rem 0.3rem;
}

button.action {
    padding-left: 1rem;
    padding-right: 1rem;
    font-size: 0.8rem;
    font-weight: 600
}
.note {
    font-weight: 100;
    font-size: 0.8rem;
}
.error {
  color:#E7505A;
}

.wait {
  cursor: wait;
}

.inner-title{
  padding-top: 1rem;
  margin-bottom: 0.3rem;
  text-align: left;
  font-size: 1.3rem;
  font-weight: 400;
}

.inner-subtitle{
  text-align: left;
  font-size: 0.8rem;
  font-weight: 300;
  margin-bottom: 0.3rem
}

.tabs {
    border-style: none;
    padding-top: 1.2rem;
    border-bottom: 1px solid #cacaca;
    padding-bottom: 0.4rem
}

.tabs li{
    float: left;
    margin-left : 0rem;
    /* padding : 0.4rem 0.8rem ; */
    margin-right : 0rem;
    /* position: relative; */
    bottom: -1px;
    margin-bottom:0rem;
}

.tabs li a {
    color:#596374;
    font-weight: 400;
    transition: background-color 0.5s,border-top-color 0.5s;
    padding : 0.4rem 0.8rem ;
}

.tabs > li a:hover {
    border-top: 2px solid #2c3e50;
}

.tabs > li a.activated {
    border: 1px solid #cacaca;
    border-bottom: 3px solid white;
    border-top: 2px solid #2c3e50;
    position: relative;
}

.inner-tab {
  padding-left: 1rem;
  padding-right: 1rem;
}

.summary {
  font-weight: 700;
}
.note {
  font-size: 0.8rem;
}
.red {
  color: #D05454
}
</style>



// WEBPACK FOOTER //
// team-purchases.vue?69b4c344